var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D5F1DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.296 11.8148H13.7775V10.3333H12.296V11.8148ZM12.296 23.6667H13.7775V22.1852H12.296V23.6667ZM15.2589 23.6667H16.7404V22.1852H15.2589V23.6667ZM9.33301 23.6667H10.8145V22.1852H9.33301V23.6667ZM9.33301 20.7037H10.8145V19.2222H9.33301V20.7037ZM9.33301 17.7408H10.8145V16.2593H9.33301V17.7408ZM9.33301 14.7778H10.8145V13.2963H9.33301V14.7778ZM9.33301 11.8148H10.8145V10.3333H9.33301V11.8148ZM21.1849 20.7037H22.6663V19.2222H21.1849V20.7037ZM21.1849 17.7408H22.6663V16.2593H21.1849V17.7408ZM21.1849 23.6667H22.6663V22.1852H21.1849V23.6667ZM21.1849 14.7778H22.6663V13.2963H21.1849V14.7778ZM21.1849 10.3333V11.8148H22.6663V10.3333H21.1849ZM15.2589 11.8148H16.7404V10.3333H15.2589V11.8148ZM18.2219 23.6667H19.7034V22.1852H18.2219V23.6667ZM18.2219 11.8148H19.7034V10.3333H18.2219V11.8148Z",
    fill: "#065A15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5404 3.1491C32.9631 2.72634 33.6472 2.72634 34.07 3.1491C34.4927 3.57187 34.4927 4.25595 34.07 4.67871L27.8983 10.8504C27.4755 11.2731 26.7914 11.2731 26.3687 10.8504L23.9304 8.41204C23.5076 7.98928 23.5076 7.3052 23.9304 6.88244C24.3531 6.45967 25.0372 6.45967 25.46 6.88244L27.1308 8.55323L32.5404 3.1491Z",
    fill: "#065A15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetIcon);
export default __webpack_public_path__ + "static/media/met-icon.34934c493ff6f36ea76dab422eeddf09.svg";
export { ForwardRef as ReactComponent };